import * as Icons from '../constants/icons';

import { EslStatistic } from '../statistics/eslStatistic';
import Layout from '../components/layout';
import React from 'react';
import SEO from '../components/seo';
import headerImage from '../images/banner/banner-4.jpg';

const TheESL = () => {
    return (
        <Layout headerTitle="Emergency Services Levy Collections and Allocations" headerImage={headerImage}>
            <SEO title="Emergency Services Levy Collections and Allocations" />
            <div className="container">
                <div className="o-section o-section--md">
                    <p>
                        In 2019-20, the Emergency Services Levy (ESL) raised $378 million from ratepayers, $4 million from local government
                        owned properties and $25 million from the State Government and non-trading State enterprises.
                    </p>
                    <p>
                        The ESL raised in 2019-20 was $14 million more than the amount expended primarily due to delayed disbursement of ESL
                        funded grants and delays to projects as a result of COVID-19. These funds are planned to be spent during the 2020-21
                        financial year. Figures have been rounded to the nearest million and include an allocation of indirect expenditure
                        of $28 million on a weighted average basis.
                    </p>
                    <p>
                        The money collected provides facilities, equipment and resources, protective clothing, uniforms, vehicles and
                        training for WA’s fire and emergency services personnel, both career and volunteer across the State.
                    </p>
                    <p>
                        The ESL also supports specialist activities across the State such as fire investigations, building inspections,
                        emergency planning and community safety programs.
                    </p>
                    <h2>Our major services and activities</h2>
                    <p>The ESL raised in 2019-20 has been used to fund the major services and activities shown below.</p>
                </div>
            </div>
            <div className="container">
                <h2 className="section-title">Table 1: Major services and activities funded through the ESL</h2>
                <div className="o-section">
                    <div className="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-3@m uk-grid">
                        <EslStatistic
                            description="Employed personnel in fire stations across Perth, Albany, Bunbury, Geraldton and Kalgoorlie who are response ready for a variety of emergency situations, 24/7."
                            value="$129 million"
                            label="Career Fire and Rescue Service"
                            icon={<Icons.ESL_Firefighters />}
                        />
                        <EslStatistic
                            description="The committed volunteers in towns and built-up areas who provide an emergency response when it is needed most."
                            value="$16 million"
                            label="Volunteer Fire and Rescue/ Fire and Emergency Services"
                            icon={<Icons.ESL_VolunteerHead />}
                        />
                        <EslStatistic
                            description="The dedicated volunteers who protect us from bushfires through fire suppression, prevention and risk management services and fire safety education in rural and pastoral areas."
                            value="$32 million"
                            label="Bush Fire Service"
                            icon={<Icons.ESL_Firehouse />}
                        />
                        <EslStatistic
                            description="The steadfast volunteers in orange who provide help to the community in a variety of situations such as severe weather and search and rescue operations."
                            value="$9 million"
                            label="State Emergency Services"
                            icon={<Icons.ESL_House />}
                        />
                        <EslStatistic
                            description="The devoted volunteers along our coastline who protect and save lives at sea."
                            value="$7 million"
                            label="Marine Rescues WA Groups"
                            icon={<Icons.ESL_Ship />}
                        />
                        <EslStatistic
                            description="Improving rural fire management through increased investment in mitigation, strengthening relationships with volunteers, and greater collaboration between agencies."
                            value="$15 million"
                            label="Rural Fire Division"
                            icon={<Icons.ESL_Fire />}
                        />
                        <EslStatistic
                            description="Providing professional development for volunteers and career personnel to enhance their operational and organisational skills."
                            value="$30 million"
                            label="Emergency Services Training"
                            icon={<Icons.ESL_Checklist />}
                        />
                        <EslStatistic
                            description="Operation and coordination of the aerial fleet that is deployed rapidly to emergency incidents, protecting lives and property during the bushfire season."
                            value="$15 million"
                            label="Aerial Firefighting and Aviation Services"
                            icon={<Icons.ESL_Helicopter />}
                        />
                        <EslStatistic
                            description="Includes construction of fire stations and other facilities as well as maintenance, improvement and replacement of facilities, response vehicles and equipment."
                            value="$60 million"
                            label="Asset Construction and Maintenance"
                            icon={<Icons.ESL_Extinguisher />}
                        />
                        <EslStatistic
                            description="Working with communities and local governments to strengthen relationships with our volunteers."
                            value="$3 million"
                            label="Volunteer Engagement"
                            icon={<Icons.ESL_Community />}
                        />
                        <EslStatistic
                            value="$9 million"
                            label="Emergency Management, Strategy and Planning"
                            icon={<Icons.ESL_Document />}
                            description="Research and planning activities to improve our services and inform decisions on how we allocate our resources."
                        />
                        <EslStatistic
                            description="Enhancing psychological and physical wellbeing for emergency services employees, volunteers and their families."
                            value="$4 million"
                            label="Health and Wellness"
                            icon={<Icons.ESL_Wellbeing />}
                        />
                        <EslStatistic
                            description="Determining the cause of fires and ensuring compliance with relevant standards to reduce the frequency and impact of emergency incidents."
                            value="$5 million"
                            label="Investigation and Compliance"
                            icon={<Icons.ESL_Checklist />}
                        />
                        <EslStatistic
                            description="Includes the running of emergency operations centres and the ‘000’ communications centre to dispatch and coordinate emergency responses."
                            value="$12 million"
                            label="Emergency Response Coordination"
                            icon={<Icons.ESL_Phone />}
                        />
                        <EslStatistic
                            description="Improving and maintaining the technology and communications infrastructure behind all our emergency services."
                            value="$29 million"
                            label="Technology and Communications"
                            icon={<Icons.ESL_Technology />}
                        />
                        <EslStatistic
                            description="Upskilling personnel and maintaining specialist equipment to enhance our emergency response across a range of events such as hazardous material spills and building collapse."
                            value="$5 million"
                            label="Special Operations"
                            icon={<Icons.ESL_Alert />}
                        />
                        <EslStatistic
                            description="Providing information and programs to communities to increase awareness and build a more resilient and safer State."
                            value="$12 million"
                            label="Community Awareness and Education"
                            icon={<Icons.ESL_Community />}
                        />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="o-section o-section--md o-section--border">
                    <p>
                        [1] ESL raised in 2019-20 was $14 million more than the amount expended primarily due to delayed disbursement of ESL
                        funded  grants and delays to projects as a result of COVID-19. These funds are planned to be spent during the
                        2020-21 financial year. Figures have been rounded to the nearest million and include an allocation of indirect
                        expenditure of $28 million on a weighted average basis. 
                    </p>
                    <h2>Grants</h2>
                    <p>
                        A summary of the ESL monies collected for direct distribution in the form of operating and capital grants is
                        reflected below. Further information on all grant expenditure is available in note 2.2 of the Financial Statements.
                    </p>

                    <table className="table-striped table-responsive">
                        <thead>
                            <tr>
                                <th style={{ width: '60%' }}></th>
                                <th className="u-text-right">Operating $’000</th>
                                <th className="u-text-right">Capital $’000</th>
                                <th className="u-text-right">Total $’000</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Local Government Grant Scheme – Bush Fire Service¹</td>
                                <td className="u-text-right">10,470</td>
                                <td className="u-text-right">13,281</td>
                                <td className="u-text-right">23,751</td>
                            </tr>
                            <tr>
                                <td>Local Government Grant Scheme – State Emergency Services¹</td>
                                <td className="u-text-right">2,393</td>
                                <td className="u-text-right">1,878</td>
                                <td className="u-text-right">4,271</td>
                            </tr>
                            <tr>
                                <td>Community Emergency Services Managers</td>
                                <td className="u-text-right">2,306</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">2,306</td>
                            </tr>
                            <tr>
                                <td>Marine Rescue WA</td>
                                <td className="u-text-right">2,331</td>
                                <td className="u-text-right">2,609</td>
                                <td className="u-text-right">4,939</td>
                            </tr>
                            <tr>
                                <td>Grants to volunteer entities</td>
                                <td className="u-text-right">896</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">896</td>
                            </tr>
                            <tr>
                                <td>Grants to volunteer representative bodies</td>
                                <td className="u-text-right">601</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">601</td>
                            </tr>
                            <tr>
                                <td>Private brigades</td>
                                <td className="u-text-right">200</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">200</td>
                            </tr>
                            <tr>
                                <td>Bushfire Risk Management Planning</td>
                                <td className="u-text-right">1,315</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">1,315</td>
                            </tr>
                            <tr>
                                <td>Mitigation</td>
                                <td className="u-text-right">5,372</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">5,372</td>
                            </tr>
                            <tr>
                                <td>ChemCentre Hazardous Materials Emergency Response</td>
                                <td className="u-text-right">1,500</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">1,500</td>
                            </tr>
                            <tr>
                                <td>Other</td>
                                <td className="u-text-right">265</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">265</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="u-text-right">
                                    <strong>27,649</strong>
                                </td>
                                <td className="u-text-right">
                                    <strong>17,767</strong>
                                </td>
                                <td className="u-text-right">
                                    <strong>45,417</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        ¹ A further $0.454 million of Local Government Grant Scheme funding was allocated towards DFES managed SES and Bush
                        Fire Brigades. A detailed breakdown of grant allocations approved to local governments for Bush Fire Brigades and
                        the State Emergency Service can be found on our website at{' '}
                        <a className="link" href="https://www.dfes.wa.gov.au/Pages/default.aspx">
                            www.dfes.wa.gov.au
                        </a>
                        .
                    </p>
                </div>
            </div>
        </Layout>
    );
};

export default TheESL;
